export const simpleDecryption = (encodedString: string) => {
  try {
    // Decode the Base64 encoded string
    const decodedString = atob(encodedString);
    return decodedString;
  } catch (error) {
    console.error("Decoding failed:", error);
    return null;
  }
};